import { render, staticRenderFns } from "./SandboxListPage.vue?vue&type=template&id=4a1890c4&scoped=true"
import script from "./SandboxListPage.vue?vue&type=script&lang=js"
export * from "./SandboxListPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a1890c4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4a1890c4')) {
      api.createRecord('4a1890c4', component.options)
    } else {
      api.reload('4a1890c4', component.options)
    }
    module.hot.accept("./SandboxListPage.vue?vue&type=template&id=4a1890c4&scoped=true", function () {
      api.rerender('4a1890c4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/apps/attributes/modules/use_cases/SandboxListPage.vue"
export default component.exports